<div class="menu_top">
  <div class="menu_top-left">
    <img src="../../../assets/images/logo/name.png" alt="">
  </div>
  <div class="menu_top-right">
    <a href='' routerLink='/synchros' routerLinkActive='is-active'>
      <span>Synchros</span>
    </a>
    <a href="" routerLink="/version-infos" routerLinkActive="is-active">
      <span>Versions</span>
    </a>
    <a href="" routerLink="/listeClients" routerLinkActive="is-active">
      <span>Clients</span>
    </a>
    <a href="" routerLink="/login" class="is-icon" routerLinkActive="is-active">
      <i class="icon icon-power"></i>
    </a>

  </div>
</div>
